import { Table, Skeleton as AntSkeleton } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ClassNameProps } from 'components/ozone-component';

interface TableSkeletonProps extends ClassNameProps {
  rowCount?: number;
  columnCount?: number;
  active?: boolean;
  size?: SizeType;
}

const StyledSkeleton = styled(AntSkeleton)`
  margin: 0;
  & .ant-skeleton-title {
    margin: 0;
    padding: 0;
    display: block;
    width: 64px;
    height: 1rem;
  }
`;

export const TableSkeleton: FC<TableSkeletonProps> = (props) => {
  const {
    active = true,
    columnCount = 5,
    rowCount = 5,
    size = 'middle',
    className,
  } = props;

  const Skeleton = () => (
    <StyledSkeleton active={active} avatar={false} paragraph={false} />
  );

  const rows = Array.from({ length: rowCount }, (_, idx) => ({
    key: `row-idx-${idx}`,
  }));
  const columns = Array.from({ length: columnCount }, (_, idx) => ({
    title: <Skeleton />,
    render: () => <Skeleton />,
    key: `col-idx-${idx}`,
  }));

  return (
    <Table
      className={className}
      size={size}
      dataSource={rows}
      columns={columns}
      pagination={false}
    />
  );
};
